import {observable, action, runInAction} from 'mobx'
import { json } from '../../../../utils/ajax'
import {handleSearchAndPage,ValueObjToObj,setStore} from '../../../../utils/Utils'

class PageStore {
    @observable visible //模态框
    @observable tabularData //列表数据
    @observable pagePagination //分页器
    @observable editFields //通过name参数判断模态框是修改还是新增
    @observable searchFields //查询页面名
    @observable isEdit //是否是编辑
    @observable editLoading //是否是loaging
    @observable modalTitle   //模态框名

    constructor(){
        this.visible=false
        this.tabularData=[]
        this.pagePagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.editFields={
            name:{}
        }
        this.searchFields={
            name:''
        }
        this.isEdit=null
        this.editLoading=false
        this.modalTitle = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }


    /*** 页面+分页+ 搜索**/
    @action
    initPage = async (page) => {
        this.editLoading=true
        let search = handleSearchAndPage(page, this.pagePagination, this.searchFields)
        const res =await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/page/pageList:search`,search);
        if (res && res.status === 0) {
            runInAction(() => {
                this.editLoading = false
            })
            return
        }
        runInAction(()=>{
            this.tabularData = res.content || []
            this.pagePagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.editLoading=false
        })

    }

    /**
     * 判断模态框是修改还是添加
     * **/
    @action
    showModal =(record) =>{
            if(record){
                this.editFields = {...this.editFields,name:{value:record.name}} //修改
                this.isEdit=record
                this.modalTitle = '修改'
            }else {
                this.editFields = {} //新增
                this.isEdit=null
                this.modalTitle = '新增'
            }
            this.visible=true
    }

    /**隐藏模态框***/
    @action
    hideModal = ()=>{
        this.visible=false
    }


    /**
     * 保存：新增/修
     */
    @action
    onSave = async () => {
        let obj = ValueObjToObj(this.editFields)
        this.editLoading=true
        if(this.isEdit){
            obj.id = this.isEdit.id
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/page/update`, obj)  //修改
        }else {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/page/add`, obj)  //新增
        }
        runInAction(()=>{
            this.visible=false
            this.editLoading=false
        })
        this.initPage(this.pagePagination.current);
    }


    /**修改：回显**/
    @action
    onEditFieldChange = (changedFields) => {
        this.editFields = {...this.editFields,...changedFields}

    }

    /**
     * 表单绑值
     * @param changedFields
     */
    @action
    onSearchFieldChange(changedFields) {

        this.searchFields = {...this.searchFields,...ValueObjToObj(changedFields)}
    }

    /**
     *  查询页面下是否有栏目
     */
    @action existCategoryType = async (pageId) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/category/under_same_page/${pageId}`)
        if (res && res.status === 0) {
            return
        } else {
            runInAction(() => {
                this.loading = false
            })
            return res.length
        }
    }
}
export default new PageStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/sparePartsCatalogueNews/Page/store.js